import { useQuery } from 'react-query'

import { BankLine } from '@modules-deprecated/bankReconciliation/types'

import { defaultStaleTime } from '../../../config/queryClient'
import { QueryKeys } from '../../../enums/queryKeys'
import { fetchBankLineMatch } from '../query-api'

interface UseFetchBankLineMatchLinesProps {
  matchId?: string
  currentBankLineId?: string
  enabled?: boolean
}

interface UseFetchBankLineMatchLinesResponse {
  linkedBankLines: BankLine[]
  isLoading: boolean
}

export const useFetchBankLineMatchLines = ({
  matchId,
  currentBankLineId,
  enabled = true,
}: UseFetchBankLineMatchLinesProps): UseFetchBankLineMatchLinesResponse => {
  const { data, isLoading } = useQuery(
    [QueryKeys.BankLineMatchLines, matchId],
    () => fetchBankLineMatch(matchId as string),
    {
      enabled: !!matchId && enabled,
      staleTime: defaultStaleTime,
    },
  )

  const linkedBankLines = (data?.bankLineMatch?.lines ?? []).filter((line) => line.id !== currentBankLineId)

  return {
    linkedBankLines,
    isLoading,
  }
}
